<template>
    <div class="lang-changing-btn" :class="device" @click="toggleLanguage">
        <div class="icon fa-solid fa-language"></div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
    name: 'LanguageChangingButton',
    props: {
        device: {
            type: String,
            required: true,
        },
    },
    setup() {
        const { locale } = useI18n()
        const toggleLanguage = () => {
            locale.value = locale.value === 'en' ? 'zh' : 'en'
            // console.log(`Language changed to: ${locale.value}`)
        }

        return { toggleLanguage }
    },
})
</script>

<style lang="scss" scoped>
.lang-changing-btn {
    cursor: pointer;
    &.desktop {
        border: none;
        border-radius: 4px;
        width: 100%;
        height: inherit;
        .icon {
            width: 100%;
            height: 2rem;
        }
    }
    &.mobile {
        background-color: #ffffff;
        box-shadow: 5px 5px 5px 2px rgba(136, 136, 136, 0.2);
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        .icon {
            width: 100%;
            height: 1.5rem;
        }
    }
}
</style>
